import app from "../_app";
[...document.querySelectorAll('.js-newsletter-signup')].map(newsletterForm => {

    const subscribe = () => {
        const identifier = newsletterForm.querySelector('input[name="identifier"]').value;
        const g = newsletterForm.querySelector('input[name="g"]').value;
        let emailAddress = newsletterForm.querySelector('input[name="email"]').value;

        var settings = {
            "g":        `${g}`,
            "$fields":  "Language",
            "email":    `${emailAddress}`,
            "Language": `${identifier}`
        }

        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method:  'POST',
            headers: {
                'Content-Type':  'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache'
            },
            body:    new URLSearchParams(settings)
        })
            .then(function (response) {
                if (response.status === 200) {
                    const newsletterSignupMessage = newsletterForm.querySelector('.js-newsletter-signup-message');
                    newsletterSignupMessage.innerText = app.translationHelper('footer.thanks');
                }
            });
    };


    newsletterForm.addEventListener('submit', e => {
        e.preventDefault();

        subscribe();
    });
});
